module.exports = __webpack_public_path__ + "img/img13.157a14b3.png";